import axios from 'axios';

export default function ApiFactory(deps, options) {
  const { dataStore } = deps;
  const { apiHost } = options;

  axios.defaults.baseURL = apiHost;

  return {
    get(url) {
      const token = dataStore.get('token');
      const config = { headers: { Authorization: `Bearer ${token}` } };
      return axios.get(url, config)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw error;
        });
    },

    put(url, data) {
      const token = dataStore.get('token');
      const config = { headers: { Authorization: `Bearer ${token}` } };
      return axios.put(url, data, config)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw error;
        });
    },

    post(url, data) {
      const token = dataStore.get('token');
      const config = { headers: { Authorization: `Bearer ${token}` } };
      return axios.post(url, data, config)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw error;
        });
    },

    delete(url) {
      const token = dataStore.get('token');
      const config = { headers: { Authorization: `Bearer ${token}` } };
      return axios.delete(url, config)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw error;
        });
    },
  };
}
